const AUDIO_INPUT_DEVICE_KEY = "libretto.preferredAudioInputDeviceId";
const VIDEO_INPUT_DEVICE_KEY = "libretto.preferredVideoInputDeviceId";
const AUDIO_OUTPUT_DEVICE_KEY = "libretto.preferredAudioOutputDeviceId";

const normalizeDeviceId = (value) => {
    if (typeof value !== "string") return "";
    return value.trim();
};

const safeReadPreference = (key) => {
    try {
        if (typeof window === "undefined") return "";
        return normalizeDeviceId(window.localStorage.getItem(key));
    } catch {
        return "";
    }
};

const safeWritePreference = (key, value) => {
    try {
        if (typeof window === "undefined") return;
        const normalized = normalizeDeviceId(value);
        if (!normalized || normalized === "none") {
            window.localStorage.removeItem(key);
            return;
        }
        window.localStorage.setItem(key, normalized);
    } catch {
        // Ignore localStorage failures (private mode, quota, etc.)
    }
};

const safeWriteOutputPreference = (value) => {
    try {
        if (typeof window === "undefined") return;
        const normalized = normalizeDeviceId(value);
        if (!normalized || normalized === "none" || normalized === "default") {
            window.localStorage.removeItem(AUDIO_OUTPUT_DEVICE_KEY);
            return;
        }
        window.localStorage.setItem(AUDIO_OUTPUT_DEVICE_KEY, normalized);
    } catch {
        // Ignore localStorage failures (private mode, quota, etc.)
    }
};

export const getPreferredAudioInputDeviceId = () => safeReadPreference(AUDIO_INPUT_DEVICE_KEY);

export const getPreferredVideoInputDeviceId = () => safeReadPreference(VIDEO_INPUT_DEVICE_KEY);

export const getPreferredAudioOutputDeviceId = () => safeReadPreference(AUDIO_OUTPUT_DEVICE_KEY);

export const setPreferredAudioInputDeviceId = (deviceId) => safeWritePreference(AUDIO_INPUT_DEVICE_KEY, deviceId);

export const setPreferredVideoInputDeviceId = (deviceId) => safeWritePreference(VIDEO_INPUT_DEVICE_KEY, deviceId);

export const setPreferredAudioOutputDeviceId = (deviceId) => safeWriteOutputPreference(deviceId);
